<div *ngIf="router.url !== '/accueil'" class="ariane">
  <nav aria-label="Fil d’ariane" class="ui-breadcrumb ui-widget ui-widget-header ui-helperclearfix ui-corner-all"
       role="navigation">
    <ul role="list">
      <li role="listitem" *ngFor="let item of menuItems;let i=index">
        <div *ngIf="i == 0; else menu_simple">
          <a class="ui-menuitem-link" [routerLink]="item.url">{{ item.label | translate }}</a>
        </div>
        <ng-template #menu_simple>
          <a class="ui-menuitem-link">{{ item.label | translate }}</a>
        </ng-template>
      </li>
    </ul>
  </nav>
</div>
